import React from "react"
import PropTypes from "prop-types"

import WPImage, { DISPLAY_MODE } from "./WPImage"

import * as twoColumnHeroWithImageLeftStyles from "../../styles/TwoColumnHeroWithImageLeft.module.css"

function TwoColumnHeroWithImageLeft(props) {
  const [elevatedHeight, setElevatedHeight] = React.useState(0)
  const [elevatedLeft, setElevatedLeft] = React.useState(0)
  const [elevatedWidth, setElevatedWidth] = React.useState(0)
  const contentRef = React.useRef(null)

  React.useLayoutEffect(() => {
    if (props.mode !== CONTAINMENT_MODE.elevated) return

    if (contentRef.current) {
      const boundingClientRef = contentRef.current.getBoundingClientRect()
      if (boundingClientRef && boundingClientRef.bottom)
        setElevatedHeight(boundingClientRef.bottom)
      if (boundingClientRef && boundingClientRef.bottom) {
        setElevatedLeft(
          boundingClientRef.left + Math.ceil(boundingClientRef.width / 2),
        )
        setElevatedWidth(Math.ceil(boundingClientRef.width / 2))
      }
    }
  }, [props.mode])


  return (
    <div
      className={`container-fluid ${twoColumnHeroWithImageLeftStyles.innerWrapper} containment-mode-${props.mode} ${props.className}`}
    >
      <div className={`row`}>
       
        <div
          className={`col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 ${twoColumnHeroWithImageLeftStyles.innerImage} ${props.imageClass}`}
        >
          <WPImage
            holder={props.imageHolder}
            selector={props.imageSelector}
            mode={props.imageDisplayMode}
            className={twoColumnHeroWithImageLeftStyles.normalContainmentImage}
          />
        </div>
         <div className={`col-12 col-lg-6 ${props.contentClass}`}>
          {props.children}
        </div>
      </div>
    </div>
  )
}

export const CONTAINMENT_MODE = {
  normal: `normal`,
  background: `background`,
  elevated: `elevated`,
}

export const IMAGE_DISPLAY_MODE = DISPLAY_MODE

TwoColumnHeroWithImageLeft.defaultProps = {
  mode: CONTAINMENT_MODE.normal,
  imageDisplayMode: DISPLAY_MODE.normal,
}

TwoColumnHeroWithImageLeft.propTypes = {
  mode: PropTypes.oneOf(Object.keys(CONTAINMENT_MODE)).isRequired,
  contentClass: PropTypes.string.isRequired,
  imageClass: PropTypes.string,
  imageHolder: PropTypes.object.isRequired,
  imageSelector: PropTypes.string.isRequired,
  imageDisplayMode: PropTypes.oneOf(Object.keys(DISPLAY_MODE)).isRequired,
}

export default TwoColumnHeroWithImageLeft
